export const getRandomInt = (max) => {
  return Math.floor(Math.random() * max); // Entre 0 et max -1
};
